import { BaseModel } from '../base-model';

export interface IDemandSite { }
export class DemandSite extends BaseModel<IDemandSite> implements IDemandSite {
  /**
   *
   */
  constructor(option?: IDemandSite) {
    super(option);
  }
}